export const environment = {
  production: true,
  pwaEnabled: false,
  languages: {
    default: 'en',
    saveKey: 'LANGUAGE'
  },
  nonce: {
    isEnabled: false,
    value: ''
  },
  enableLogs: false,
};